import React from 'react'

import CareersMap from 'components/shared/CareersMap'
import Intro from 'components/slices/Intro'

import css from './styles.module.scss'

const CareersHero = ({ intro, nodes }) => {
  return (
    <div className={css.CareersHero}>
      <Intro {...intro} />
      <CareersMap nodes={nodes} />
    </div>
  )
}

CareersHero.defaultProps = {}

export default CareersHero
